import React, { useState } from 'react';
import { Layout } from 'antd';
import { useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

const { Content } = Layout;

interface MenuItem {
  key: string;
  icon: React.ReactNode;
  label: string;
  path: string;
}

interface LayoutShellProps {
  children: React.ReactNode;
  menuItems: MenuItem[];
  user?: {
    name?: string;
    email?: string;
    role?: string;
  };
  onLogout: () => void;
  breadcrumbs?: Array<{ path: string; label: string }>;
  showBreadcrumbs?: boolean;
  topbarActions?: React.ReactNode;
}

export const LayoutShell: React.FC<LayoutShellProps> = ({
  children,
  menuItems,
  user,
  onLogout,
  breadcrumbs,
  showBreadcrumbs = true,
  topbarActions,
}) => {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();

  // Auto-collapse sidebar on smaller screens
  React.useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setCollapsed(true);
      }
    };

    handleResize(); // Check on mount
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sidebar
        collapsed={collapsed}
        menuItems={menuItems}
        currentPath={location.pathname}
        onLogout={onLogout}
      />
      <Layout
        style={{
          marginLeft: collapsed ? 64 : 240,
          transition: 'margin-left 0.2s',
        }}
        className="main-layout-content"
      >
        <Topbar
          collapsed={collapsed}
          onToggleCollapse={() => setCollapsed(!collapsed)}
          user={user}
          onLogout={onLogout}
          breadcrumbs={breadcrumbs}
          showBreadcrumbs={showBreadcrumbs}
          actions={topbarActions}
        />
        <Content className="admin-layout-content">
          <div style={{ maxWidth: '100%', width: '100%' }}>{children}</div>
        </Content>
      </Layout>
    </Layout>
  );
};
